'use client';
import { ActiveFilterChips } from '@hyphengroup/cms-components/cms-blocks/SortAndFilterPanel/ActiveFilterChips';
import type { ActiveFilterRemoval } from '@hyphengroup/cms-components/cms-blocks/SortAndFilterPanel/ActiveFilterChips';
import React, { useCallback } from 'react';
import type { VerticalType } from '../../types';
import { trackActiveFilterRemove } from './tracking';
import { usePanelTrackingContext } from './usePanelTrackingContext';

/**
 * The applied-filter chips plus their analytics, for the same reason the panel
 * has a wrapper: the block is shared and the events are the app's.
 */
export const ActiveFilterChipsWrapper: React.FC<{
  /** The row sits beside the panel, so it reports the panel's position. */
  blockIndex?: number;
  /** The page's vertical, which decides how a filter group is reported. */
  vertical?: VerticalType;
}> = ({ blockIndex, vertical }) => {
  const context = usePanelTrackingContext(blockIndex, vertical);

  const onRemove = useCallback(
    (removal: ActiveFilterRemoval) => trackActiveFilterRemove(context, removal),
    [context],
  );

  return <ActiveFilterChips onRemove={onRemove} />;
};
